import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./add-deceased-name.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./add-deceased-name.component.scss?ngResource";
import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SharedConstants } from "../../../../../../shared/constants/shared.constants";
import { AlertType } from "../../../../../../shared/models/alert";
import { CreateApplicationDeceasedCmConstants } from "../create-application-deceased-cm.constants";
import { AppControllerService } from "../../../../../../app-controller.service";
import { AppConfig } from "../../../../../../app.config";
let AddDeceasedNameComponent = class AddDeceasedNameComponent {
    activeModal;
    appController;
    modalTitle;
    recordCount = 0;
    dateofBirth;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    addForm;
    cancelLabel = SharedConstants.CANCEL_LABEL;
    createLabel = SharedConstants.CREATE_LABEL;
    validationMessages = CreateApplicationDeceasedCmConstants.VALIDATION_MESSAGES;
    nameLabel = CreateApplicationDeceasedCmConstants.NAME_LABEL;
    surnameLabel = CreateApplicationDeceasedCmConstants.SURNAME_LABEL;
    startDateLabel = CreateApplicationDeceasedCmConstants.START_DATE_LABEL;
    nameFormControlName = CreateApplicationDeceasedCmConstants.NAME_FORM_CONTROL_NAME;
    surnameFormControlName = CreateApplicationDeceasedCmConstants.SURNAME_FORM_CONTROL_NAME;
    startDateFormControlName = CreateApplicationDeceasedCmConstants.START_DATE_FORM_CONTROL_NAME;
    constructor(activeModal, appController) {
        this.activeModal = activeModal;
        this.appController = appController;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
    }
    ngOnInit() {
        this.addForm = new FormGroup({
            name: new FormControl(null, [Validators.required]),
            surname: new FormControl(null, [Validators.required]),
            startDate: new FormControl(this.dateofBirth)
        });
        if (this.recordCount === 0) {
            this.startDateLabel = "Date of birth";
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onBtnSaveClicked($event) {
        if (this.addForm.valid) {
            const name = {
                name: this.addForm.get(this.nameFormControlName).value,
                surname: this.addForm.get(this.surnameFormControlName).value,
                startDate: this.addForm.get(this.startDateFormControlName).value,
            };
            this.activeModal.close(name);
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onBtnCancelClicked($event) {
        this.activeModal.close(null);
    }
    static ctorParameters = () => [
        { type: NgbActiveModal },
        { type: AppControllerService }
    ];
    static propDecorators = {
        modalTitle: [{ type: Input }],
        recordCount: [{ type: Input }],
        dateofBirth: [{ type: Input }]
    };
};
AddDeceasedNameComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-add-deceased-name",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], AddDeceasedNameComponent);
export { AddDeceasedNameComponent };
